import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Breadcrumb, BackdropCircular } from 'components';
import {
  getDepositByIdApi,
  getDepositPaymentByIdApi
} from 'api';
import {
  Tab,
  Tabs,
} from '@material-ui/core';
import { useStyles } from '../styles';
import EditDepositDetails from './EditDepositDetails';
import EditDepositPayment from './EditDepositPayment';


const EditDeposit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { entity_id, order_id } = useParams<{ entity_id: string, order_id: string }>();
  const [tabValue, setTabValue] = useState('details');

  const {
    isDepositLoading,
    isDepositPaymentLoading
  } = useSelector((state: IReduxState) => state.deposits);

  useEffect(() => {
    getDepositByIdApi({ dispatch, id: entity_id });
    getDepositPaymentByIdApi({ dispatch, id: entity_id });
  }, []);

  return (
    <div className="flex-grow flex-column relative h-full scroll-y pb-5">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Deposits', path: '/deposits'},
            { name: order_id}
          ]}
        />
      </div>
      <div className={`${classes.card} px-5`}>
        <div className={`${classes.tabsContainer} ${classes.tabIndicator} pt-5 px-5 flex justify-between w-full`}>
          <Tabs
            value={tabValue}
            onChange={(e, newValue) => setTabValue(newValue)}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{ style: { display: 'none' } }}
          >
            <Tab
              label="Details"
              value="details"
              className={tabValue === 'details' ? classes.activeTab : classes.inactiveTab}
            />
            <Tab
              label="Payment"
              value="payment"
              className={tabValue === 'payment' ? classes.activeTab : classes.inactiveTab}
            />
          </Tabs>
        </div>
        <div>
          {tabValue === 'details' && <EditDepositDetails />}
          {tabValue === 'payment' && <EditDepositPayment />}
        </div>
      </div>
      <BackdropCircular loading={isDepositLoading || isDepositPaymentLoading} />
    </div>
  );
};

export default EditDeposit;
